(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const bindGallery = (root) => {
      if (!root) {
        return;
      }

      if (root.dataset.gridThumbsBound === 'true' && root.__gridThumbsCleanup) {
        return;
      }

      if (root.__gridThumbsCleanup) {
        root.__gridThumbsCleanup();
        delete root.__gridThumbsCleanup;
      }

      const grid = root.querySelector('[data-media-grid]');
      const thumbnails = Array.from(
        root.querySelectorAll('.product-media-gallery__thumbs .slideshow-controls__thumbnail')
      );

      if (!grid || thumbnails.length === 0) {
        return;
      }

      const mediaItems = Array.from(grid.querySelectorAll('[data-media-index]'));
      if (mediaItems.length === 0) {
        return;
      }

      let activeIndex = thumbnails.findIndex((thumb) => thumb.getAttribute('aria-selected') === 'true');
      if (activeIndex < 0) {
        activeIndex = 0;
      }

      let suppressScrollUpdatesUntil = 0;
      let pendingIndex = null;
      let pendingTimeoutAt = 0;
      let scrollAnimationFrame = null;
      let scrollAnimationTimeout = null;
      let restoreScrollBehavior = null;

      const getPageScrollTop = () => window.scrollY || window.pageYOffset || 0;

      const productGalleryScrollEase = (progress) => {
        if (progress <= 0) {
          return 0;
        }

        if (progress >= 1) {
          return 1;
        }

        return 1 - Math.pow(1 - progress, 3);
      };

      const cancelScrollAnimation = () => {
        if (scrollAnimationFrame !== null) {
          cancelAnimationFrame(scrollAnimationFrame);
          scrollAnimationFrame = null;
        }

        if (scrollAnimationTimeout !== null) {
          clearTimeout(scrollAnimationTimeout);
          scrollAnimationTimeout = null;
        }

        if (restoreScrollBehavior) {
          restoreScrollBehavior();
          restoreScrollBehavior = null;
        }
      };

      const getThumbAlignmentTop = () => {
        const thumbsWrap = root.querySelector('.product-media-gallery__thumbs');

        if (thumbsWrap) {
          const wrapRect = thumbsWrap.getBoundingClientRect();
          if (Number.isFinite(wrapRect.top) && wrapRect.top > 0) {
            return wrapRect.top;
          }

          const computedTop = parseFloat(window.getComputedStyle(thumbsWrap).top || '');
          if (Number.isFinite(computedTop)) {
            return computedTop;
          }
        }

        const gridRect = grid.getBoundingClientRect();
        return Math.max(0, gridRect.top);
      };

      const getDocumentMaxScrollTop = () => {
        const documentElement = document.documentElement;
        const body = document.body;
        const scrollHeight = Math.max(
          documentElement?.scrollHeight || 0,
          body?.scrollHeight || 0,
          documentElement?.offsetHeight || 0,
          body?.offsetHeight || 0
        );
        const viewportHeight = window.innerHeight || documentElement?.clientHeight || 0;

        return Math.max(0, scrollHeight - viewportHeight);
      };

      const getProductSectionEndScrollTop = () => {
        const section = root.closest('.product-information') || root.closest('.shopify-section');
        if (!(section instanceof HTMLElement)) {
          return getDocumentMaxScrollTop();
        }

        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const sectionBottom = section.getBoundingClientRect().bottom + getPageScrollTop();

        return Math.max(0, Math.min(sectionBottom - viewportHeight, getDocumentMaxScrollTop()));
      };

      const scrollMediaIntoAlignment = (target) => {
        if (!target) {
          return;
        }

        const alignmentTop = getThumbAlignmentTop();
        const targetTop = target.getBoundingClientRect().top + getPageScrollTop();
        const targetIndex = mediaItems.indexOf(target);
        const targetAlignmentTop = Math.max(0, targetTop - alignmentTop);
        const naturalSectionEndTop = getProductSectionEndScrollTop();
        const nextTop =
          targetIndex === mediaItems.length - 1
            ? Math.max(targetAlignmentTop, naturalSectionEndTop)
            : Math.min(targetAlignmentTop, getDocumentMaxScrollTop());
        const startTop = getPageScrollTop();
        const distance = nextTop - startTop;
        const documentElement = document.documentElement;
        const body = document.body;
        const originalDocumentScrollBehavior = documentElement.style.scrollBehavior;
        const originalBodyScrollBehavior = body ? body.style.scrollBehavior : '';
        let scrollBehaviorLocked = false;

        const lockNativeScrollBehavior = () => {
          if (scrollBehaviorLocked) {
            return;
          }

          documentElement.style.scrollBehavior = 'auto';

          if (body) {
            body.style.scrollBehavior = 'auto';
          }

          scrollBehaviorLocked = true;
          restoreScrollBehavior = restoreNativeScrollBehavior;
        };

        const restoreNativeScrollBehavior = () => {
          if (!scrollBehaviorLocked) {
            return;
          }

          documentElement.style.scrollBehavior = originalDocumentScrollBehavior;

          if (body) {
            body.style.scrollBehavior = originalBodyScrollBehavior;
          }

          scrollBehaviorLocked = false;
          restoreScrollBehavior = null;
        };

        if (Math.abs(distance) < 1) {
          cancelScrollAnimation();
          window.scrollTo(0, nextTop);
          return 0;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          cancelScrollAnimation();
          window.scrollTo(0, nextTop);
          return 0;
        }

        cancelScrollAnimation();
        lockNativeScrollBehavior();

        const duration = clamp(760 + Math.abs(distance) * 0.2, 900, 1280);
        const animationStart = performance.now();

        const step = (now) => {
          const progress = clamp((now - animationStart) / duration, 0, 1);
          const eased = productGalleryScrollEase(progress);
          const currentTop = startTop + distance * eased;

          window.scrollTo(0, currentTop);

          if (progress < 1) {
            scrollAnimationFrame = requestAnimationFrame(step);
          } else {
            window.scrollTo(0, nextTop);
            restoreNativeScrollBehavior();
            scrollAnimationFrame = null;
            if (scrollAnimationTimeout !== null) {
              clearTimeout(scrollAnimationTimeout);
              scrollAnimationTimeout = null;
            }
          }
        };

        scrollAnimationTimeout = window.setTimeout(() => {
          window.scrollTo(0, nextTop);
          restoreNativeScrollBehavior();
          scrollAnimationFrame = null;
          scrollAnimationTimeout = null;
        }, duration + 48);

        scrollAnimationFrame = requestAnimationFrame(step);

        return duration;
      };

      const scrollThumbnailIntoView = (thumb) => {
        if (!thumb) {
          return;
        }

        const scrollContainer = thumb.closest('.slideshow-controls__thumbnails-container');
        if (!scrollContainer) {
          return;
        }

        const canScrollVertically = scrollContainer.scrollHeight > scrollContainer.clientHeight + 1;
        const canScrollHorizontally = scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;

        if (!canScrollVertically && !canScrollHorizontally) {
          return;
        }

        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };

      const setActiveThumbnail = (index, { scrollThumb = true, force = false } = {}) => {
        if (index < 0 || index >= thumbnails.length) {
          return;
        }

        if (!force && index === activeIndex) {
          return;
        }

        activeIndex = index;

        thumbnails.forEach((thumb, idx) => {
          thumb.setAttribute('aria-selected', idx === index ? 'true' : 'false');
        });

        if (scrollThumb) {
          const activeThumb = thumbnails[index];
          scrollThumbnailIntoView(activeThumb);
        }
      };

      const getMostVisibleState = () => {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        let bestIndex = activeIndex;
        let bestRatio = 0;

        mediaItems.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const height = rect.height || 1;
          const visibleTop = clamp(rect.top, 0, viewportHeight);
          const visibleBottom = clamp(rect.bottom, 0, viewportHeight);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);
          const ratio = visibleHeight / height;

          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestIndex = index;
          }
        });

        return { index: bestIndex, ratio: bestRatio };
      };

      const updateFromScroll = () => {
        const now = typeof performance !== 'undefined' ? performance.now() : Date.now();

        if (pendingIndex !== null) {
          if (now < suppressScrollUpdatesUntil) {
            return;
          }
        } else if (now < suppressScrollUpdatesUntil) {
          return;
        }

        const { index: nextIndex, ratio } = getMostVisibleState();

        if (pendingIndex !== null) {
          if (nextIndex === pendingIndex && ratio >= 0.6) {
            setActiveThumbnail(nextIndex, { scrollThumb: true, force: true });
            pendingIndex = null;
            suppressScrollUpdatesUntil = 0;
          } else if (now > pendingTimeoutAt) {
            pendingIndex = null;
          }
          return;
        }

        if (nextIndex !== activeIndex) {
          setActiveThumbnail(nextIndex, { scrollThumb: true });
        }
      };

      const observer = new IntersectionObserver(updateFromScroll, {
        threshold: [0, 0.25, 0.5, 0.75, 1],
      });

      const thumbnailHandlers = new Map();

      mediaItems.forEach((item, index) => {
        item.dataset.mediaIndex = index;
        observer.observe(item);
      });

      thumbnails.forEach((thumb, index) => {
        thumb.dataset.mediaIndex = index;
        const handleClick = (event) => {
          event.preventDefault();
          const target = mediaItems[index];
          const duration = target ? scrollMediaIntoAlignment(target) : 0;

          if (typeof performance !== 'undefined') {
            const now = performance.now();
            suppressScrollUpdatesUntil = now + Math.max(duration, 450);
            pendingTimeoutAt = now + Math.max(duration + 1200, 2000);
          } else {
            const now = Date.now();
            suppressScrollUpdatesUntil = now + Math.max(duration, 450);
            pendingTimeoutAt = now + Math.max(duration + 1200, 2000);
          }

          pendingIndex = index;
          setActiveThumbnail(index, { scrollThumb: false, force: true });
        };
        thumb.addEventListener('click', handleClick);
        thumbnailHandlers.set(thumb, handleClick);
      });

      setActiveThumbnail(activeIndex, { scrollThumb: false, force: true });

      root.__gridThumbsCleanup = () => {
        cancelScrollAnimation();
        observer.disconnect();
        thumbnailHandlers.forEach((handler, thumb) => {
          thumb.removeEventListener('click', handler);
        });
        root.removeAttribute('data-grid-thumbs-bound');
      };

      root.dataset.gridThumbsBound = 'true';
    };

    const bindAll = (scope = document) => {
      const galleries = scope.querySelectorAll?.('[data-product-media-gallery="grid"]');
      if (!galleries) {
        return;
      }

      galleries.forEach((gallery) => {
        bindGallery(gallery);
      });
    };

    const scheduleBindAll = (scope = document) => {
      bindAll(scope);
      window.setTimeout(() => bindAll(scope), 250);
      window.setTimeout(() => bindAll(scope), 1000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleBindAll());
    } else {
      scheduleBindAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      scheduleBindAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const galleries = event.target.querySelectorAll?.('[data-product-media-gallery="grid"]');
      galleries?.forEach((gallery) => {
        gallery.__gridThumbsCleanup?.();
        delete gallery.__gridThumbsCleanup;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    (() => {
    const tablesMeasured = new WeakSet();

    const measureTables = (tables) => {
      tables.forEach((table) => {
        if (!(table instanceof HTMLTableElement)) return;

        table.setAttribute('data-measuring', 'true');
        table.style.removeProperty('--popup-cell-min-width');
        table.style.removeProperty('--popup-table-min-width');

        const cells = table.querySelectorAll('th, td');
        let widestCell = 0;

        cells.forEach((cell) => {
          widestCell = Math.max(widestCell, Math.ceil(cell.scrollWidth));
        });

        if (widestCell > 0) {
          const buffer = 24; // generous breathing room for mobile view
          const minWidth = widestCell + buffer;
          table.style.setProperty('--popup-cell-min-width', `${minWidth}px`);

          const firstRow = table.rows[0];
          if (firstRow) {
            let columnCount = 0;
            Array.from(firstRow.cells).forEach((cell) => {
              columnCount += cell.colSpan || 1;
            });

            if (columnCount > 0) {
              table.style.setProperty('--popup-table-min-width', `${minWidth * columnCount}px`);
            }
          }
        }

        table.removeAttribute('data-measuring');
        tablesMeasured.add(table);
      });
    };

    const unwrap = (scope = document) => {
      scope.querySelectorAll?.('.popup-link__header').forEach((header) => {
        const parent = header.parentNode;
        while (header.firstChild) {
          parent.insertBefore(header.firstChild, header);
        }
        header.remove();
      });

      scope.querySelectorAll?.('.popup-link__table-scroll').forEach((wrapper) => {
        const table = wrapper.querySelector('table');
        if (table) {
          table.style.removeProperty('--popup-cell-min-width');
          table.style.removeProperty('--popup-table-min-width');
          wrapper.parentNode.insertBefore(table, wrapper);
        }
        wrapper.remove();
      });
    };

    const wrap = (scope = document) => {
      const inners = scope.querySelectorAll?.('.popup-link__inner');
      if (!inners) return;

      inners.forEach((inner) => {
        const directChildren = Array.from(inner.children);
        const firstTableIndex = directChildren.findIndex(
          (child) => child.tagName === 'TABLE'
        );

        if (firstTableIndex > 0) {
          const headerWrapper = document.createElement('div');
          headerWrapper.className = 'popup-link__header';
          for (let i = 0; i < firstTableIndex; i += 1) {
            headerWrapper.appendChild(directChildren[i]);
          }
          inner.insertBefore(headerWrapper, inner.firstChild);
        }

        const tables = Array.from(inner.querySelectorAll('table')).filter(
          (table) => table.parentElement === inner
        );

        tables.forEach((table) => {
          if (table.closest('.popup-link__table-scroll')) return;

          const wrapper = document.createElement('div');
          wrapper.className = 'popup-link__table-scroll';
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        });

        measureTables(tables);
      });
    };

    const init = (scope = document) => {
      unwrap(scope);
      wrap(scope);
      measureTables(Array.from(scope.querySelectorAll('.popup-link__table-scroll table')));
    };

    const onReady = () => init(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady, { once: true });
    } else {
      onReady();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => unwrap(event.target));

    let resizeFrame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        measureTables(Array.from(document.querySelectorAll('.popup-link__table-scroll table')));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
